import { AuthCarousel } from '@/components/auth/auth-carousel';
import { BrandLogo } from '@/components/brand/brand-logo';
import type { ReactNode } from 'react';

// Split-screen auth shell: full-height image carousel on the left (lg+ only),
// the form slot centered on the right. Layout replicated from the blogzilla
// reference; the right panel keeps the existing bordered <Card> forms.
export function AuthLayout({
  children,
  testId,
}: {
  children: ReactNode;
  testId?: string;
}) {
  return (
    <main
      data-testid={testId}
      className="grid min-h-dvh w-full grid-cols-1 overflow-hidden lg:h-dvh lg:grid-cols-2"
    >
      <div data-testid="auth-carousel-col" className="hidden lg:block">
        <AuthCarousel />
      </div>
      <div className="relative flex min-h-dvh flex-col items-center justify-center bg-background px-4 py-10 sm:px-6 lg:min-h-0">
        {/* Tagline lockup; theme-aware dark variant swaps in via CSS on the
            .dark class — matched dimensions, no invert filter, no layout shift. */}
        <BrandLogo
          variant="tagline"
          className="absolute left-6 top-6 h-12 w-auto md:left-8 md:top-8"
        />
        {children}
      </div>
    </main>
  );
}
